export default __webpack_public_path__ + "static/media/fe-credit-signature.c9889f75.png";